var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvestor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7925 5.52343C21.5825 6.31346 21.5825 7.59435 20.7925 8.38438C20.0025 9.17441 18.7216 9.17441 17.9316 8.38438C17.1415 7.59435 17.1415 6.31346 17.9316 5.52343C18.7216 4.7334 20.0025 4.7334 20.7925 5.52343",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2026 1.91236C15.4191 3.12884 15.4191 5.10115 14.2026 6.31764C12.9861 7.53412 11.0138 7.53412 9.79732 6.31764C8.58084 5.10116 8.58084 3.12885 9.79732 1.91236C11.0138 0.69588 12.9861 0.69588 14.2026 1.91236",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.06848 5.52343C6.85851 6.31346 6.85851 7.59435 6.06848 8.38438C5.27845 9.17441 3.99756 9.17441 3.20753 8.38438C2.4175 7.59435 2.4175 6.31346 3.20753 5.52343C3.99756 4.7334 5.27845 4.7334 6.06848 5.52343",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23 15.0001V13.9041C23 12.5231 21.881 11.4041 20.5 11.4041H19.699",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 15.0001V13.9041C1 12.5231 2.119 11.4041 3.5 11.4041H4.301",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.339 14.9999V13.3989C17.339 11.4659 15.772 9.89893 13.839 9.89893H10.16C8.227 9.89893 6.66 11.4659 6.66 13.3989V14.9999",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestor);
export default __webpack_public_path__ + "static/media/investor.4985fc15d7b2edc24b52f6a5fbee2436.svg";
export { ForwardRef as ReactComponent };